import { shouldEnableOptionalCookies } from './cookie-consent.service'

export const COUNTER_ID = 53599684
const STORAGE_KEY = 'gl_analytics_sent_v1'
const GOALS = new Set(['cart_added', 'checkout_started', 'payment_succeeded', 'print_request_created', 'callback_requested'])
const sent = new Set()
let active = false
let installed = false
let currentPath = '/'

function allowed () {
  return typeof window !== 'undefined' && ['gorkyliquid.ru', 'www.gorkyliquid.ru'].includes(window.location.hostname) && shouldEnableOptionalCookies()
}

function safePath (value) {
  const path = String(value || '/').split(/[?#]/)[0]
  // Account paths may contain order IDs; never send them or reset tokens to Metrika.
  return /^\/(panel|login|registration|reset-password)(\/|$)/.test(path) ? '/account' : path
}

function call (...args) {
  try {
    if (active && allowed()) window.ym(COUNTER_ID, ...args)
  } catch { /* Analytics must never interrupt checkout. */ }
}

function hit () {
  call('hit', `https://gorkyliquid.ru${safePath(currentPath)}`, { title: 'Gorky Liquid', referer: '' })
}

function updateConsent () {
  if (!allowed()) {
    if (active) {
      try { window.ym(COUNTER_ID, 'destruct') } catch {}
    }
    active = false
    return
  }
  if (active) return
  window.ym = window.ym || function () { (window.ym.a = window.ym.a || []).push(arguments) }
  window.ym.l = window.ym.l || Date.now()
  window.dataLayer = window.dataLayer || []
  active = true
  call('init', {
    defer: true,
    ecommerce: 'dataLayer',
    accurateTrackBounce: true,
    webvisor: false,
    clickmap: false,
    trackLinks: false,
    url: `https://gorkyliquid.ru${safePath(currentPath)}`,
    referrer: ''
  })
  if (!document.querySelector('script[data-gl-metrika]')) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://mc.yandex.ru/metrika/tag.js'
    script.dataset.glMetrika = 'true'
    document.head.appendChild(script)
  }
  hit()
}

export function setupAnalytics (router) {
  if (installed || typeof window === 'undefined') return
  installed = true
  currentPath = router.currentRoute.value.path
  window.addEventListener('gl-cookie-consent-updated', updateConsent)
  updateConsent()
  router.afterEach((to, from, failure) => {
    if (failure || to.path === currentPath) return
    currentPath = to.path
    hit()
  })
}

function once (key, send) {
  if (!active || !allowed()) return
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')
    if (Array.isArray(stored)) stored.slice(-200).forEach(value => sent.add(value))
  } catch {}
  if (sent.has(key)) return
  send()
  sent.add(key)
  try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...sent].slice(-200))) } catch {}
}

export function trackGoal (name, { kind } = {}) {
  if (!GOALS.has(name)) return
  call('reachGoal', name, ['shop', 'study', 'print'].includes(kind) ? { kind } : {})
}

export function trackCheckout (order) {
  if (!order?.id || order.reservation_status === 'released') return
  once(`checkout-${order.id}`, () => trackGoal('checkout_started', { kind: 'shop' }))
}

function ecommerce (data) {
  if (active && allowed()) {
    try { window.dataLayer.push({ ecommerce: { currencyCode: 'RUB', ...data } }) } catch {}
  }
}

export function trackCartAddition (product, quantity = 1) {
  if (!product?.id || !Number.isFinite(quantity) || quantity <= 0) return
  trackGoal('cart_added', { kind: 'shop' })
  ecommerce({ add: { products: [{ id: String(product.id), name: String(product.name || ''), price: Number(product.price), quantity }] } })
}

export function trackVerifiedPurchase (payment) {
  if (payment?.test_mode !== false || payment?.is_paid !== true || payment?.status !== 'succeeded') return
  const data = payment.analytics
  if (!data?.id || !Array.isArray(data.products) || !data.products.length || !(Number(data.revenue) > 0)) return
  once(`purchase-${data.id}`, () => {
    trackGoal('payment_succeeded', { kind: payment.kind })
    ecommerce({
      purchase: {
        actionField: { id: String(data.id), revenue: Number(data.revenue) },
        products: data.products.map(product => ({ id: String(product.id), name: String(product.name), price: Number(product.price), quantity: Number(product.quantity) }))
      }
    })
  })
}
